import anime from 'animejs';

export default {
  install(Vue, options) {
    Vue.mixin({
      methods: {
        scrollTo(arg) {
          let el = document.querySelector(arg.to),
            offset = parseInt(arg.offset) || 0,
            duration = arg.duration || 800,
            easing = arg.easing || 'easeOutExpo',
            callback = arg.callback || null;
          if (el) {
            anime({
                targets: ['html', 'body'],
                scrollTop: (el.offsetTop - offset) - 120,
                duration: duration,
                easing: easing,
                complete: callback
              })
              .finished.then(() => {
                bus.$emit('scroll:finished', true);
              });
          }
        }
      }
    });


  }
}



// WEBPACK FOOTER //
// ./src/plugins/mixin_style.js